import { TipSuggestion } from 'olo-service';

export const DOORDASH_TIP_15: TipSuggestion = {
  id: 'dd15',
  name: 'DOORDASH_TIP_15',
  percentage: 15,
};

export const DOORDASH_TIP_18: TipSuggestion = {
  id: 'dd18',
  name: 'DOORDASH_TIP_18',
  percentage: 18,
};

export const DOORDASH_TIP_20: TipSuggestion = {
  id: 'dd20',
  name: 'DOORDASH_TIP_20',
  percentage: 20,
};

export const DOORDASH_TIP_25: TipSuggestion= {
  id: 'dd25',
  name: 'DOORDASH_TIP_25',
  percentage: 25,
};

export const DOORDASH_DEFAULT_TIP_SUGGESTION: TipSuggestion = DOORDASH_TIP_20;

export const DOORDASH_TIP_SUGGESTIONS: TipSuggestion[] = [
  DOORDASH_TIP_15,
  DOORDASH_TIP_18,
  DOORDASH_TIP_20,
  DOORDASH_TIP_25,
];
